import "./search.css";
import { MagnifyingGlassFill } from "../../../../../assets";
import { Icon } from "../../../../icon";
import { OperationSearchProps } from "./search.props";

const OperationSearch: React.FC<OperationSearchProps> = ({
  show,
  placeholder,
  value,
  setValue,
  className,
  disabled = false,
}) => {
  return (
    <>
      {show && (
        <div className={`operation-search-wrapper ${className}`}>
          <input
            id="operation-search"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            className="operation-search-input"
          />
          <label htmlFor="operation-search" className="operation-search-label">
            <Icon
              icon={MagnifyingGlassFill}
              alt="Icon search"
              className="operation-search-icon"
            />
          </label>
        </div>
      )}
    </>
  );
};

export default OperationSearch;
